import React from "react";

const TruncateWord = ({ strng, charLimit = 30 }) => {
  if (!strng) return null;

  const trimmed = strng.trim();

  if (trimmed.length <= charLimit) {
    return <span title={trimmed}>{trimmed}</span>;
  }

  const truncated = trimmed.slice(0, charLimit) + " ...";
  return <span title={trimmed}>{truncated}</span>;
};

export default TruncateWord;
